import React from 'react';
import type { ICellRendererParams } from 'ag-grid-community';
import type { ReviewCellRendererProps } from '../helpers';
import { FormatAndPerformanceCellRenderer } from './FormatAndPerformanceCellRenderer';
import { SparklineCellRenderer } from './SparklineCellRenderer';

export const SparklineWithFormatAndPerformanceCellRenderer = (props: ICellRendererParams & ReviewCellRendererProps) => {
  return (
    <div className="flex gap-[8px] items-center py-[8px]">
      <SparklineCellRenderer {...props} />
      <FormatAndPerformanceCellRenderer {...props} />
    </div>
  );
};
